import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getExpiryDocReport = async ({
  fromDate = "",
  toDate = "",
  companyCode,
  locationCode,
  passCode = 0,
  employeeCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  let url = isAllCompanies
    ? Api_EndPoints.AllCompanies_GetEmployeesExpiryReport
    : Api_EndPoints.GetExpiryDocReport;
  let queryString = `?companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;

  if (isAllCompanies && userId !== 0) {
    queryString += `&UserId=${userId}`;
  }

  if (fromDate !== "" && toDate !== "") {
    queryString += `&Fromdate=${fromDate}&Todate=${toDate}`;
  }

  if (passCode !== 0) {
    queryString += `&PassCode=${passCode}`;
  }

  if (employeeCode !== 0) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }
  const { data } = await http_payroll.get(`${url}${queryString}`);
  return data;
};

export const useExpiryDocReportQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetEmployeesExpiryReport
        : Api_EndPoints.GetExpiryDocReport,
      input,
    ],
    queryFn: () => getExpiryDocReport(input),
    refetchOnWindowFocus: false,
  });
};
